export default "/images/d3452db1af34d9198f8d3bd72533534c.jpg";